import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=0362a7e4&"
import script from "./FileItem.vue?vue&type=script&lang=ts&"
export * from "./FileItem.vue?vue&type=script&lang=ts&"
import style0 from "./FileItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports